'use client'
// Umami-Tracking (cookielos/anonym, First-Party via /s/-Proxy).
// Dieselbe Next-App liefert hub.dj-allianz.de UND djsuche.eu aus — die Property
// wird deshalb clientseitig nach Host/Pfad gewählt: DJ-Suche-Seiten zählen in die
// „DJ Suche"-Property, alles andere in die Hub-Property. Lädt nur, wenn die
// jeweilige Website-ID gesetzt ist (nur PROD).
import { useEffect } from 'react'
import { installiereUmamiBotFilter, UMAMI_FILTER_NAME } from '@/lib/umami-botfilter'

export default function UmamiScript({ hubId, djsucheId }: { hubId?: string; djsucheId?: string }) {
  useEffect(() => {
    const h = location.hostname
    const p = location.pathname
    const isDjsuche = h === 'djsuche.eu' || h === 'www.djsuche.eu' || p === '/djsuche' || p.startsWith('/djsuche/')
    const id = isDjsuche ? djsucheId : hubId
    if (!id) return
    if (document.querySelector('script[src="/s/script.js"]')) return
    installiereUmamiBotFilter()
    const s = document.createElement('script')
    s.defer = true
    s.src = '/s/script.js'
    s.setAttribute('data-website-id', id)
    s.setAttribute('data-before-send', UMAMI_FILTER_NAME)
    document.body.appendChild(s)
  }, [hubId, djsucheId])
  return null
}
